import React from 'react';
import { OnHandBoxOutline } from './brand/OnHandLogo';

/*
  A whole screen with nothing on it yet.

  Written 8 September 2026 for "Build the Ordering area". **Four of Group G's
  nine screens are drawings over nothing**: no replenishment run, no client
  order and no movement run has ever been saved in any of the three companies,
  and no shorthand has ever been mapped. On those screens the drawing signed off
  on 4 September makes the EMPTY version the primary one, not an afterthought,
  because it is what a person actually meets, every time.

  Its shape is the same on all four, so it is one component:

    a mark, quiet, in a rounded square
    what there is none of, as a heading
    two or three sentences saying what would put something here and why it is
      worth having
    the one act that starts it, if there is one

  **The paragraph is the part that matters and it is not filler.** Rule 9 and
  rule 35: an empty screen that says only "No runs yet" tells somebody the
  screen is broken. One that says what a run is, and what it would keep, tells
  them what to do next. Every caller passes real sentences.

  Nothing here is glass (rule 3), the act is a real button on the tap floor
  (rule 13), and the whole thing sits inside one card so it behaves at every
  width (rule 21).
*/

/*
  **One screen gets its own mark and a dashed edge**, added 8 September 2026 by
  walking Group G's nine against the app. Movement's Pages screen is the one
  place in OnHand where you can drop files onto the screen itself, and nothing
  said so: it drew the same solid card as every other empty screen. Its approved
  drawing has a dashed edge and a camera, and both are information rather than
  decoration, because photographing a page is what the screen is for.

  Nothing else passes `drop`, so every other empty screen is untouched.
*/
function Camera() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true"
      stroke="var(--info)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  );
}

export default function EmptyScreen({ title, says, action, children, drop }) {
  return (
    <div className={'card empty-screen' + (drop ? ' is-drop' : '')}>
      {/* The logo's box outline, muted (rebrand step 3, guide 11.8). A drop
          zone keeps its camera, which says what to drop. */}
      <span className="empty-screen-mark">{drop ? <Camera /> : <OnHandBoxOutline size={44} />}</span>
      <div className="empty-screen-title">{title}</div>
      {says && <div className="empty-screen-says">{says}</div>}
      {children}
      {action && (
        <button type="button" className="btn btn-primary empty-screen-act" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
